import React from 'react';
import {observer} from 'mobx-react';
import MultiSelectFilter from 'main/components/tables/interactive/components/fancy_filter/filter_selector/MultiSelectFilter';
import generateTitle from 'main/components/tables/interactive/components/fancy_filter/filter_selector/generateTitle';
import Spinner from 'shared/components/spinners/Spinner';

const FilterComponent = observer(({filter, filterKey, filterUpdated, filterDeleted, options, fallbackTitle, searchable, Wrapper, isLoading = false}) => {
  const selectedValues = filter.get(filterKey) ? filter.get(filterKey).split(',') : [];
  const selectedLabels = selectedValues.map(value => {
    const selectedOption = options.find(option => option.value === value);
    return selectedOption ? (selectedOption.pillTitle || selectedOption.label) : '';
  });

  return (
    <Wrapper title={generateTitle(selectedLabels, filterKey, fallbackTitle)} onRemove={() => filterDeleted(filterKey)}>
      {isLoading ?
        <Spinner/> :
        <MultiSelectFilter options={options} filterKey={filterKey} filter={filter} filterUpdated={filterUpdated} isLoading={isLoading} searchable={searchable}/>
      }
    </Wrapper>
  );
});

export default FilterComponent;
